// bao migrate skip
import "./../services/bao-shouter";
import "./../services/finito-service";
import BaoDialog from "./bao-dialog";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import finitoService from "../services/finito-service";
import baoShouter from "../services/bao-shouter";
import { TabPage } from "./tab-page";

class SubscriptionViewModel {
    //1. Observables müssen immer im Constructor definiert werden (da es sont nur eine Instanz der observable gibt!)
    //2. In der Kindklasse, muss im Constructor die Basis Klasse(n) aufgerufen werden - mit Hilfe von BaseClass.apply(this, arguments)
    //3. Nach der Definition der Klassen (Kind und Eltern), kann mit Hilfe der Helperfunktion Bao.inherit(child, parent) die Vererbung erstellt werden
    TabPage: TabPage;
    SettingsUrl: KnockoutObservable<string> = ko.observable(null);
    SettingsKeyPermission: KnockoutObservable<string> = ko.observable(null);
    SettingsKeyPermissionApplicationId: KnockoutObservable<string> = ko.observable(null);
    Subscriptions;
    constructor(tabPage) {
        this.TabPage = tabPage;
        this.Subscriptions = [];
    }
    ;
    subscribe(observable, fn) {
        this.Subscriptions.push(observable.subscribe(fn));
    }
    ;
    dispose() {
        ko.utils.arrayForEach(this.Subscriptions, (s: any) => {
            s.dispose();
        });
    }
    ;
    showValidationErrors() {
        var dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.CheckRequiredFields), 'info');
    }
    ;
    showAlert(messageKey, type?, duration: number = null) {
        if (!type) {
            type = 'success';
        }
        var message = Bao.Session.GetMessage(messageKey);
        // HACK: show shouter if message is loaded ... ( boa extension is planned to get better code ... )
        if (message() !== "") {
            baoShouter.show(message(), type, duration);
        }
        else {
            var sub = message.subscribe((msg) => {
                baoShouter.show(msg, type, duration);
                sub.dispose();
            });
        }
    }
    ;
}
;
export default SubscriptionViewModel;